import React, { createContext, useState, useEffect, useContext } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useUser } from "./UserContext";

// Create the SessionContext
export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [sessions, setSessions] = useState([]);
  const { userData, loading } = useUser(); // Get user data from UserContext
  const parishId = userData?.parishId; // Extract parishId when available

  useEffect(() => {
    if (loading) {
      console.log("⏳ Waiting for authentication to finish before fetching sessions...");
      return; // Don't run Firestore query until auth is fully loaded
    }

    if (!userData) {
      console.warn("⚠️ User data not available yet. Skipping session fetch.");
      return;
    }

    if (!parishId) {
      console.warn("⚠️ No parishId found in userData, skipping session fetch.");
      return;
    }

    console.log(`🟢 Fetching sessions for Parish ID: ${parishId}`);

    const q = query(collection(db, "sessions"), where("parishId", "==", parishId));

    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        console.log(`🔥 Firestore Query Executed for Parish ID: ${parishId}`);

        if (!querySnapshot.empty) {
          const sessionData = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            sessionId: doc.id,
          }));

          console.log(`✅ Fetched ${sessionData.length} sessions`);
          setSessions(sessionData);
        } else {
          console.warn(`⚠️ No sessions found for parish ${parishId}`);
          setSessions([]);
        }
      },
      (error) => {
        console.error("❌ Firestore Query Error:", error);
      }
    );

    return () => unsubscribe();
  }, [parishId, userData, loading]); // Runs only when userData is fully available

  return (
    <SessionContext.Provider value={{ sessions, setSessions }}>
      {children}
    </SessionContext.Provider>
  );
};
